var map = {
	"./DayTraderCanda.png": 4425,
	"./areaChart.svg": 1163,
	"./candleChart.svg": 523,
	"./csv.svg": 4398,
	"./design.css": 139,
	"./lang/en": 5725,
	"./lang/en.json": 5725,
	"./lang/fr": 7102,
	"./lang/fr.json": 7102,
	"./lineChart.svg": 7384,
	"./logo-daytrader-dark.svg": 2131,
	"./logo.png": 3153,
	"./logout.svg": 3180,
	"./plainText.svg": 4959,
	"./theme.css": 4874,
	"./workstation.svg": 415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;